import type { CSSProperties } from 'react';

// Exibicao unica do ESTOQUE EFETIVO de um produto fracionado: proprio + o que o pai
// gera por fracionamento (pai x fator). E o numero que o caixa realmente deixa vender,
// porque o "enviar-caixa"/"finalizar venda" auto-fraciona o pai quando o filho falta (DA-261).
// Peca so de APRESENTACAO: a conta vem pronta do backend (estoque_efetivo); aqui so formata,
// mostra a quebra "do pai" e pinta vermelho quando nem o pai cobre o pedido.

function fmtEstoque(n: number): string {
  return Number.isInteger(n)
    ? n.toLocaleString('pt-BR')
    : n.toLocaleString('pt-BR', { maximumFractionDigits: 3 });
}

interface Props {
  /** Estoque proprio do produto (estoque_atual). */
  proprio: number | null;
  /** Estoque efetivo = proprio + (pai x fator). Se null, cai pro proprio. */
  efetivo: number | null;
  /** Quantidade necessaria (ex.: qtd do item). Pinta vermelho quando efetivo < necessario. */
  necessario?: number | null;
  /** Modo enxuto pra coluna estreita: so o numero + marcador/tooltip (sem "do pai" inline). */
  compacto?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function EstoqueEfetivo({ proprio, efetivo, necessario, compacto, className, style }: Props) {
  const ef = efetivo ?? proprio;
  if (ef == null) {
    return <span className={className} style={style}>-</span>;
  }
  const pr = proprio ?? ef;
  const doPai = Math.max(0, ef - pr);
  const temPai = doPai > 0;
  const insuficiente = necessario != null && ef < necessario;
  const corClasse = insuficiente ? 'text-red-600 font-semibold' : undefined;

  const tooltip = temPai
    ? `Estoque efetivo: ${fmtEstoque(pr)} proprio + ${fmtEstoque(doPai)} do pai (fracionamento) = ${fmtEstoque(ef)}` +
      (insuficiente ? '\nInsuficiente: nem o fracionamento do pai cobre o pedido.' : '')
    : `Estoque: ${fmtEstoque(ef)}` + (insuficiente ? ' (insuficiente)' : '');

  return (
    <span className={[corClasse, className].filter(Boolean).join(' ') || undefined} style={style} title={tooltip}>
      {fmtEstoque(ef)}
      {temPai && !compacto && (
        <span className="text-gray-400 font-normal"> (+{fmtEstoque(doPai)} do pai)</span>
      )}
      {temPai && compacto && (
        <sup className="text-[9px] text-blue-500 ml-0.5" aria-hidden="true">*</sup>
      )}
    </span>
  );
}
